export const GET_EXPERIENCES = 'GET_EXPERIENCES';
export const SELECT_EXPERIENCE = 'SELECT_EXPERIENCE';
